
import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import CategoriesContent from "./content";
import GenreChildPageSkeleton from "../common/Skeleton/GenreChildPageSkeleton";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

export default function SpitialMoftabakh({ data, loading = false }) {
  return (
    <div className="legacy-app-shell">
      <div className="legacy-app-shell-sidebar">
        <Menu focusKey="MENU" />
      </div>
      <div className="legacy-app-shell-content">
        {loading ? (
          <GenreChildPageSkeleton isParent={false} rows={3} cols={5} />
        ) : (
          <CategoriesContent data={data} />
        )}
      </div>
    </div>
  );
}

